import React, { Component } from 'react';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
import Big3Common from "../../js/Big3Common";

/**
 * 개발담당:양유빈
 * 화면기능:alert 창, 결과 메세지 창
 * -------- props --------
 * id: 필수 | 모달을 구분 하기 위한 id 값
 * AlertClick: 옵션 | 확인 버튼 클릭후 callback 이벤트를 위한 속성 ex) AlertClick={this.handleAlertClick }
 * icoin: 옵션 | 미 지정시 기본 아이콘 지정
 * title: 필수 | 경고 안내 타이틀
 * content: 필수 | 안내 메세지 문구
 * zIndex: 옵션 | 여러 레이어를 사용할때 순서 정의, 기본값은 2000 이며 최대 9999
 **/
export class Alert extends Component {
    static displayName = Alert.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleClick = this.handleClick.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    componentDidCatch(error, info) {
        console.log(Alert.displayName + ": 에러");
        console.log({
            error,
            info
        });
    }
    //확인 버튼과 동시에 부모 페이지의 함수를 호출
    handleClick() {
        let modalID = this.props.id;
        var modalEl = document.getElementById(modalID)
        var thismodal = bootstrap.Modal.getInstance(modalEl) 
        thismodal.hide();
        //모달이 여러개 뜨는경우가 있어 처리
        Big3Common.HistoryBackToClearBackdoor();
        if (this.props.AlertClick !== undefined) {
            this.props.AlertClick(modalID);
        }
        
    }
    render() {
        return (
            <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false"
                data-bs-backdrop={this.props.backdrop === undefined ? "static" : this.props.backdrop}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <div className="icon icon-alert"></div>

                            <div className="desc">
                                <div className="modal_title">{this.props.title}</div>
                                <div className="modal_txt" dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn" data-bs-dismiss="modal" onClick={this.handleClick}>확인</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
